import { confirmSurveyAction } from "./confirmSurveyAction";

/**
 * Runs lock (+ optional report) + resink. Returns true on success (caller
 * should close the dialog); false on failure (dialog stays open; onError
 * has been called).
 *
 * generateReport is only chained when the lock itself succeeded.
 * Error copy lives on ApiSurveys lock/report options.error.
 */
export async function confirmLockSurvey(params: {
  lock: () => Promise<unknown>;
  generateReport: (() => Promise<unknown>) | null;
  resink: () => Promise<unknown>;
  onError: (message: string) => void;
}): Promise<boolean> {
  return confirmSurveyAction({
    run: params.lock,
    resink: params.resink,
    onError: params.onError,
    fallback: "Failed to lock survey",
    afterSuccess: params.generateReport
      ? {
          run: params.generateReport,
          fallback: "Survey locked, but report generation failed",
        }
      : null,
  });
}

/**
 * Runs unlock + resink. Returns true on success; false on failure
 * (onError has been called).
 */
export async function confirmUnlockSurvey(params: {
  unlock: () => Promise<unknown>;
  resink: () => Promise<unknown>;
  onError: (message: string) => void;
}): Promise<boolean> {
  return confirmSurveyAction({
    run: params.unlock,
    resink: params.resink,
    onError: params.onError,
    fallback: "Failed to unlock survey",
  });
}
